import { Box } from 'components/Box';

import {
  STAFF_PAGE_HEADER_NAV_MAP,
  STAFF_PAGE_HEADER_PATH_MAP,
} from './StaffPageHeaderConstants';
import { StaffPageHeaderTopNavLink } from './StaffPageHeaderTopNavLink';
import { useStaffPageHeaderIsActive } from './useStaffPageHeaderIsActive';

type Props = {
  index: number;
  navOption: keyof typeof STAFF_PAGE_HEADER_NAV_MAP;
};

export function StaffPageHeaderMainLink({ index, navOption }: Props) {
  const { isActive, navInactive } = useStaffPageHeaderIsActive();

  return (
    <Box height="100%" key={navOption}>
      <StaffPageHeaderTopNavLink
        index={index}
        linkTo={STAFF_PAGE_HEADER_PATH_MAP[navOption]}
        type={navOption}
        isActive={isActive}
        navInactive={navInactive}
      />
    </Box>
  );
}
